export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/LA-bf56db1aada7aa937befea2ef0d78bb8.png";